import styleInject from '../node_modules/style-inject/dist/153f6fceb51bb0547b1c47281772019ca2a83d6f1f66a0d8c0fb968a56fe84d7.cfe-internal.js';

var css_248z = "._3qw4j{flex-shrink:0}";
var styles = {"icon":"_3qw4j"};
styleInject(css_248z);

export { styles as default };
